export default "__VITE_ASSET__BZH6grLq__"